import { useState } from 'react';
import { useActiveDigitalBill } from '../../../context/DigitalBillStore';
import { useLocation } from '../../../context/LocationContext';
import { useCartStore } from '../../../context/cart/CartStore';
import { useQueryDigitalBillDetails } from '../../../hooks/useDigitalBillApi';
import { isBillLimitReached, wouldExceedBillLimit } from '../../../utils/digitalBillUtils';
import BillLimitCard from '../../DigitalBill/unsettled/sidebar/details/BillLimit/BillLimitCard';
import EditBillLimitDialog from '../../DigitalBill/unsettled/sidebar/details/BillLimit/EditBillLimitDialog';
import { useCancelBillLimitRequest } from '../../DigitalBill/unsettled/sidebar/details/BillLimit/useCancelBillLimitRequest';

/**
 * The bill limit card in the cart, shown only when it needs attention: the bill is at
 * max (red state), or the cart's items would push it past the limit (will-exceed
 * warning). Bills without a limit, or with room to spare, render nothing.
 */
const CartBillLimit = () => {
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const activeDigitalBill = useActiveDigitalBill();
  const { location, isDigitalBillEnabled } = useLocation();
  const cartTotalPrice = useCartStore((x) => x.cart.totalPrice);
  const { data: digitalBill } = useQueryDigitalBillDetails(
    isDigitalBillEnabled,
    location.locationId,
    activeDigitalBill?.reference
  );
  const billLimit = digitalBill?.billLimit;
  const { cancelRequest, isCancelRequestPending } = useCancelBillLimitRequest(
    activeDigitalBill?.reference ?? '',
    billLimit
  );
  const isReached = isBillLimitReached(billLimit);
  const willExceed = !isReached && wouldExceedBillLimit(cartTotalPrice, billLimit);

  if (!digitalBill || !billLimit || (!isReached && !willExceed)) {
    return null;
  }

  return (
    <div className="px-4 pt-3">
      <BillLimitCard
        billLimit={billLimit}
        showWillExceedWarning={willExceed}
        onEdit={() => setOpenEditDialog(true)}
        onCancelRequest={cancelRequest}
        isCancelRequestPending={isCancelRequestPending}
      />
      {openEditDialog && (
        <EditBillLimitDialog digitalBill={digitalBill} billLimit={billLimit} onClose={() => setOpenEditDialog(false)} />
      )}
    </div>
  );
};

export default CartBillLimit;
